// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — footer.styled.classic.js, новая — footer.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './footer.styled.classic';
import * as cp from './footer.styled.cp';

export const Button = isCp ? cp.Button : classic.Button;
export const Content = isCp ? cp.Content : classic.Content;
export const PrimaryButton = isCp ? cp.PrimaryButton : classic.PrimaryButton;
